import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholderSmartLinkEditor: {
		id: 'backlog-ai-work-creation-panel.src.view.smart-link-editor.placeholder-smart-link-editor',
		defaultMessage: 'Describe what needs to be done, or <link>search Confluence</link>.',
		description:
			'Placeholder for Smart Link editor, tells user either to type work item summary or to paste a link.',
	},
});
